import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export const MetaPixelTracker = () => {
  const { pathname } = useLocation();
  const last = useRef(pathname);
  useEffect(() => {
    if (last.current === pathname) {
      return;
    }
    last.current = pathname;
    if (typeof window.fbq === "function") {
      window.fbq("track", "PageView");
    }
  }, [pathname]);
  useEffect(() => {
    const isWa = (u) => /wa\.me|whatsapp\.com|whatsapp:/i.test(String(u || ""));
    const fire = () => { if (typeof window.fbq === "function") { window.fbq("track", "Contact"); } };
    const onClick = (e) => {
      const a = e.target.closest && e.target.closest("a[href]");
      if (a && isWa(a.getAttribute("href"))) { fire(); }
    };
    const origOpen = window.open;
    window.open = function (u, ...rest) {
      if (isWa(u)) { fire(); }
      return origOpen.call(window, u, ...rest);
    };
    document.addEventListener("click", onClick, true);
    return () => {
      document.removeEventListener("click", onClick, true);
      window.open = origOpen;
    };
  }, []);
  return null;
};

export default MetaPixelTracker;
